import { render, staticRenderFns } from "./edite-team.vue?vue&type=template&id=192aa5f4&scoped=true"
import script from "./edite-team.vue?vue&type=script&lang=js"
export * from "./edite-team.vue?vue&type=script&lang=js"
import style0 from "./edite-team.vue?vue&type=style&index=0&id=192aa5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192aa5f4",
  null
  
)

export default component.exports